import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private notifications: string[] = [];
  private notificationStatus: BehaviorSubject<boolean[]> = new BehaviorSubject<boolean[]>([]);

  constructor() {}

  getNotifications(): string[] {
    return this.notifications;
  }

  getNotificationStatus(): BehaviorSubject<boolean[]> {
    return this.notificationStatus;
  }

  addNotification(message: string): void {
    this.notifications.push(message);
    this.notificationStatus.value.push(false);
    this.notificationStatus.next(this.notificationStatus.value);
  }

  markAsRead(index: number): void {
    this.notificationStatus.value[index] = true;
    this.notificationStatus.next(this.notificationStatus.value);
  }
}
